module.exports = __webpack_public_path__ + "static/img/061.57bef3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/061.png
// module id = gm7I
// module chunks = 0